module.exports = __webpack_public_path__ + "media/images/top-content-img-7-7956c26726c494009ab94f0c132db42c.jpg";